import axios from '@/lib/axios';

export interface HelpArticle {
  _id?: string;
  articleType: 'detailed';
  category: string;
  title: string;
  content: string;
  shortDescription?: string;
  order: number;
  status: 'active' | 'inactive';
  feedbackStats?: {
    helpful: number;
    notHelpful: number;
  };
  metadata?: {
    createdBy?: {
      _id: string;
      name: string;
      email: string;
    };
    updatedBy?: {
      _id: string;
      name: string;
      email: string;
    };
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface HelpArticleFilters {
  page?: number;
  limit?: number;
  status?: 'active' | 'inactive';
  articleType?: 'quick' | 'detailed';
  category?: string;
  search?: string;
}

export interface HelpArticleListResponse {
  status: string;
  results: number;
  total: number;
  page: number;
  totalPages: number;
  statistics: {
    total: number;
    active: number;
    inactive: number;
  };
  data: HelpArticle[];
}

export const helpArticleService = {
  // Get all help articles with pagination and filters (Super Admin)
  async getArticles(filters: HelpArticleFilters = {}): Promise<HelpArticleListResponse> {
    const { data } = await axios.get('/help-articles/admin/all', {
      params: filters
    });
    return data;
  },

  // Get help article by ID
  async getArticleById(id: string): Promise<{ status: string; data: HelpArticle }> {
    const { data } = await axios.get(`/help-articles/admin/${id}`);
    return data;
  },

  // Create new help article
  async createArticle(article: Omit<HelpArticle, '_id' | 'createdAt' | 'updatedAt' | 'metadata' | 'feedbackStats'>): Promise<{ status: string; message: string; data: HelpArticle }> {
    const { data } = await axios.post('/help-articles/admin', article);
    return data;
  },

  // Update help article
  async updateArticle(id: string, article: Partial<HelpArticle>): Promise<{ status: string; message: string; data: HelpArticle }> {
    const { data } = await axios.patch(`/help-articles/admin/${id}`, article);
    return data;
  },

  // Delete help article
  async deleteArticle(id: string): Promise<{ status: string; message: string }> {
    const { data } = await axios.delete(`/help-articles/admin/${id}`);
    return data;
  },

  // Get unique categories
  async getCategories(): Promise<{ status: string; data: string[] }> {
    const { data } = await axios.get('/help-articles/admin/categories');
    return data;
  }
};
